import AtomicPreloader from './components/preloader/AtomicPreloader';
import Constellation from './components/functions/Constellation';
import CustomCursor from './components/functions/CustomCursor';
import BackToTop from './components/functions/BackToTop';
import BottomNav from './components/bottomnav/BottomNav';

/**
 * Shared app shell rendered identically on the server (prerender) and client
 * (hydration). Keeping this tree identical on both sides is what lets
 * hydrateRoot reuse the prerendered DOM instead of discarding it.
 */
export default function AppShell({ children }) {
  return (
    <>
      <AtomicPreloader />
      <Constellation />
      <CustomCursor />
      <BackToTop />
      <BottomNav />
      {children}
    </>
  );
}
